import 'slick-carousel'

export default () => {

  function slickCarouselb() {
    $('.product-inner__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      infinite: false,
      rtl: $('html').attr('lang') === 'ar' ? true : false,
      prevArrow: `<button type="button" class="slick-prev">
                    <span class="arrow-icon">
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="ar-1" fill="white">
                    <path d="M9.04652 0.635359C8.86604 0.454879 8.58191 0.454879 8.40143 0.635359C8.22705 0.809741 8.22705 1.09997 8.40143 1.27395L11.6724 4.54494L0.878598 4.54494C0.626984 4.54494 0.420489 4.74493 0.420489 4.99654C0.420489 5.24816 0.626983 5.45465 0.878598 5.45465L11.6724 5.45465L8.40143 8.71955C8.22705 8.90003 8.22705 9.19066 8.40143 9.36464C8.58191 9.54512 8.86604 9.54512 9.04652 9.36464L13.0919 5.31929C13.2663 5.14491 13.2663 4.85468 13.0919 4.68071L9.04652 0.635359Z"/>
                    </mask>
                    <path d="M9.04652 0.635359C8.86604 0.454879 8.58191 0.454879 8.40143 0.635359C8.22705 0.809741 8.22705 1.09997 8.40143 1.27395L11.6724 4.54494L0.878598 4.54494C0.626984 4.54494 0.420489 4.74493 0.420489 4.99654C0.420489 5.24816 0.626983 5.45465 0.878598 5.45465L11.6724 5.45465L8.40143 8.71955C8.22705 8.90003 8.22705 9.19066 8.40143 9.36464C8.58191 9.54512 8.86604 9.54512 9.04652 9.36464L13.0919 5.31929C13.2663 5.14491 13.2663 4.85468 13.0919 4.68071L9.04652 0.635359Z" fill="white"/>
                    <path d="M9.04652 0.635359L9.75363 -0.0717476L9.04652 0.635359ZM8.40143 1.27395L9.10771 0.566016L9.10854 0.566841L8.40143 1.27395ZM11.6724 4.54494L12.3795 3.83783L14.0866 5.54494L11.6724 5.54494L11.6724 4.54494ZM11.6724 5.45465L11.6724 4.45465L14.0898 4.45465L12.3789 6.16242L11.6724 5.45465ZM8.40143 8.71955L7.68228 8.02469L7.68857 8.01818L7.69498 8.01178L8.40143 8.71955ZM8.40143 9.36464L9.10771 8.65671L9.10854 8.65753L8.40143 9.36464ZM9.04652 9.36464L8.33942 8.65753L9.04652 9.36464ZM13.0919 5.31929L13.799 6.0264L13.0919 5.31929ZM13.0919 4.68071L12.3856 5.38864L12.3848 5.38781L13.0919 4.68071ZM8.33942 1.34247C8.54946 1.55251 8.89849 1.55251 9.10854 1.34247L7.69432 -0.071748C8.26533 -0.642752 9.18263 -0.642752 9.75363 -0.0717476L8.33942 1.34247ZM9.10854 1.34247C9.32422 1.12678 9.32541 0.783208 9.10771 0.566017L7.69515 1.98188C7.12869 1.41674 7.12987 0.492702 7.69432 -0.071748L9.10854 1.34247ZM9.10854 0.566841L12.3795 3.83783L10.9653 5.25205L7.69432 1.98105L9.10854 0.566841ZM11.6724 5.54494L0.878598 5.54494L0.878599 3.54494L11.6724 3.54494L11.6724 5.54494ZM0.878598 5.54494C1.16054 5.54494 1.42049 5.31575 1.42049 4.99654L-0.579511 4.99654C-0.57951 4.1741 0.0934233 3.54494 0.878599 3.54494L0.878598 5.54494ZM1.42049 4.99654C1.42049 4.69587 1.17927 4.45465 0.878598 4.45465L0.878598 6.45465C0.0746974 6.45465 -0.579511 5.80044 -0.579511 4.99654L1.42049 4.99654ZM0.878598 4.45465L11.6724 4.45465L11.6724 6.45465L0.878598 6.45465L0.878598 4.45465ZM12.3789 6.16242L9.10788 9.42731L7.69498 8.01178L10.966 4.74689L12.3789 6.16242ZM9.12058 9.4144C9.31364 9.21459 9.33198 8.88046 9.10771 8.65671L7.69515 10.0726C7.12211 9.50087 7.14046 8.58546 7.68228 8.02469L9.12058 9.4144ZM9.10854 8.65753C8.89849 8.44749 8.54946 8.44749 8.33942 8.65753L9.75363 10.0717C9.18262 10.6428 8.26533 10.6427 7.69432 10.0717L9.10854 8.65753ZM8.33942 8.65753L12.3848 4.61219L13.799 6.0264L9.75363 10.0717L8.33942 8.65753ZM12.3848 4.61219C12.1691 4.82787 12.1679 5.17145 12.3856 5.38864L13.7982 3.97277C14.3646 4.53792 14.3634 5.46195 13.799 6.0264L12.3848 4.61219ZM12.3848 5.38781L8.33942 1.34247L9.75363 -0.0717476L13.799 3.9736L12.3848 5.38781Z" fill="white" mask="url(#ar-1)"/>
                    </svg>
                    </span>
                  </button>`,
      nextArrow: `<button type="button" class="slick-next">
                    <span class="arrow-icon">
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="ar-2" fill="white">
                    <path d="M9.04652 0.635359C8.86604 0.454879 8.58191 0.454879 8.40143 0.635359C8.22705 0.809741 8.22705 1.09997 8.40143 1.27395L11.6724 4.54494L0.878598 4.54494C0.626984 4.54494 0.420489 4.74493 0.420489 4.99654C0.420489 5.24816 0.626983 5.45465 0.878598 5.45465L11.6724 5.45465L8.40143 8.71955C8.22705 8.90003 8.22705 9.19066 8.40143 9.36464C8.58191 9.54512 8.86604 9.54512 9.04652 9.36464L13.0919 5.31929C13.2663 5.14491 13.2663 4.85468 13.0919 4.68071L9.04652 0.635359Z"/>
                    </mask>
                    <path d="M9.04652 0.635359C8.86604 0.454879 8.58191 0.454879 8.40143 0.635359C8.22705 0.809741 8.22705 1.09997 8.40143 1.27395L11.6724 4.54494L0.878598 4.54494C0.626984 4.54494 0.420489 4.74493 0.420489 4.99654C0.420489 5.24816 0.626983 5.45465 0.878598 5.45465L11.6724 5.45465L8.40143 8.71955C8.22705 8.90003 8.22705 9.19066 8.40143 9.36464C8.58191 9.54512 8.86604 9.54512 9.04652 9.36464L13.0919 5.31929C13.2663 5.14491 13.2663 4.85468 13.0919 4.68071L9.04652 0.635359Z" fill="white"/>
                    <path d="M9.04652 0.635359L9.75363 -0.0717476L9.04652 0.635359ZM8.40143 1.27395L9.10771 0.566016L9.10854 0.566841L8.40143 1.27395ZM11.6724 4.54494L12.3795 3.83783L14.0866 5.54494L11.6724 5.54494L11.6724 4.54494ZM11.6724 5.45465L11.6724 4.45465L14.0898 4.45465L12.3789 6.16242L11.6724 5.45465ZM8.40143 8.71955L7.68228 8.02469L7.68857 8.01818L7.69498 8.01178L8.40143 8.71955ZM8.40143 9.36464L9.10771 8.65671L9.10854 8.65753L8.40143 9.36464ZM9.04652 9.36464L8.33942 8.65753L9.04652 9.36464ZM13.0919 5.31929L13.799 6.0264L13.0919 5.31929ZM13.0919 4.68071L12.3856 5.38864L12.3848 5.38781L13.0919 4.68071ZM8.33942 1.34247C8.54946 1.55251 8.89849 1.55251 9.10854 1.34247L7.69432 -0.071748C8.26533 -0.642752 9.18263 -0.642752 9.75363 -0.0717476L8.33942 1.34247ZM9.10854 1.34247C9.32422 1.12678 9.32541 0.783208 9.10771 0.566017L7.69515 1.98188C7.12869 1.41674 7.12987 0.492702 7.69432 -0.071748L9.10854 1.34247ZM9.10854 0.566841L12.3795 3.83783L10.9653 5.25205L7.69432 1.98105L9.10854 0.566841ZM11.6724 5.54494L0.878598 5.54494L0.878599 3.54494L11.6724 3.54494L11.6724 5.54494ZM0.878598 5.54494C1.16054 5.54494 1.42049 5.31575 1.42049 4.99654L-0.579511 4.99654C-0.57951 4.1741 0.0934233 3.54494 0.878599 3.54494L0.878598 5.54494ZM1.42049 4.99654C1.42049 4.69587 1.17927 4.45465 0.878598 4.45465L0.878598 6.45465C0.0746974 6.45465 -0.579511 5.80044 -0.579511 4.99654L1.42049 4.99654ZM0.878598 4.45465L11.6724 4.45465L11.6724 6.45465L0.878598 6.45465L0.878598 4.45465ZM12.3789 6.16242L9.10788 9.42731L7.69498 8.01178L10.966 4.74689L12.3789 6.16242ZM9.12058 9.4144C9.31364 9.21459 9.33198 8.88046 9.10771 8.65671L7.69515 10.0726C7.12211 9.50087 7.14046 8.58546 7.68228 8.02469L9.12058 9.4144ZM9.10854 8.65753C8.89849 8.44749 8.54946 8.44749 8.33942 8.65753L9.75363 10.0717C9.18262 10.6428 8.26533 10.6427 7.69432 10.0717L9.10854 8.65753ZM8.33942 8.65753L12.3848 4.61219L13.799 6.0264L9.75363 10.0717L8.33942 8.65753ZM12.3848 4.61219C12.1691 4.82787 12.1679 5.17145 12.3856 5.38864L13.7982 3.97277C14.3646 4.53792 14.3634 5.46195 13.799 6.0264L12.3848 4.61219ZM12.3848 5.38781L8.33942 1.34247L9.75363 -0.0717476L13.799 3.9736L12.3848 5.38781Z" fill="white" mask="url(#ar-2)"/>
                    </svg>
                    </span>
                  </button>`
    });
  }
  slickCarouselb();
  function slickCarousels() {
    $('.product-inner__add-slider').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      accessibility: false,
      focusOnSelect: true,
      arrows: false,
      rtl: $('html').attr('lang') === 'ar' ? true : false,
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }
  slickCarousels();


  $('#tab-1 .products-list').each(function() {
    const arrowContainer = $(this).parents('.products-slider').find('.products-slider__top').children('.products-slider__top-box');
    $(this).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      appendArrows: arrowContainer,
      rtl: $('html').attr('lang') === 'ar' ? true : false,
      prevArrow: `<button type="button" class="slick-prev first-arrow">
                    <svg width="61" height="8" viewBox="0 0 61 8" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.646442 4.35355C0.45118 4.15829 0.45118 3.84171 0.646442 3.64645L3.82842 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.73079 0.659728 4.73079 0.976311 4.53553 1.17157L1.7071 4L4.53553 6.82843C4.73079 7.02369 4.73079 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82842 7.53553L0.646442 4.35355ZM61 4.5H0.999996V3.5H61V4.5Z" />
                    </svg>
                  </button>`,
      nextArrow: `<button type="button" class="slick-next first-arrow">
                    <svg width="61" height="8" viewBox="0 0 61 8" xmlns="http://www.w3.org/2000/svg">
                      <path d="M60.3536 4.35355C60.5488 4.15829 60.5488 3.84171 60.3536 3.64645L57.1716 0.464466C56.9763 0.269204 56.6597 0.269204 56.4645 0.464466C56.2692 0.659728 56.2692 0.976311 56.4645 1.17157L59.2929 4L56.4645 6.82843C56.2692 7.02369 56.2692 7.34027 56.4645 7.53553C56.6597 7.7308 56.9763 7.7308 57.1716 7.53553L60.3536 4.35355ZM0 4.5H60V3.5H0V4.5Z" />
                    </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 1
          }
        }
      ]
    });
  });


  $('.review__slider').each(function() {
    $(this).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      rtl: $('html').attr('lang') === 'ar' ? true : false,
        responsive: [
          {
            breakpoint: 1679,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          }
        ]
    });
  });

  $('.wishes__list').each(function() {
    $(this).slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      rtl: $('html').attr('lang') === 'ar' ? true : false,
        responsive: [
          {
            breakpoint: 1679,
            settings: {
              slidesToShow: 6
            }
          },
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          }
        ]
    });
  });

  $('.our-team__list').each(function() {
    $(this).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      rtl: $('html').attr('lang') === 'ar' ? true : false,
        responsive: [
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          }
        ]
    });
  });

  $('.programm__slider').each(function() {
    $(this).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      rtl: $('html').attr('lang') === 'ar' ? true : false,
        responsive: [
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          }
        ]
    });
  });

}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js